import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const TruncatedText = ({
  children,
  width,
  variant: Variant,
  maxLines,
  multiline,
  withoutTooltip,
  className,
  ...rest
}) => {
  const [isEllipsisActive, setEllipsisActive] = useState(false);
  const textRef = useRef();

  useEffect(() => {
    const handleResize = () => {
      const offsetCheck = multiline
        ? textRef.current?.offsetHeight < textRef.current?.scrollHeight
        : textRef.current?.offsetWidth < textRef.current?.scrollWidth;

      setEllipsisActive(offsetCheck);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [textRef, isEllipsisActive, multiline]);

  const styleObject = {
    maxWidth: width,
    overflow: 'hidden',
    whiteSpace: multiline ? 'break-spaces' : 'nowrap',
    textOverflow: 'ellipsis',
    ...(multiline && { WebkitLineClamp: maxLines }),
  };

  return (
    <Variant
      title={isEllipsisActive ? children : ''}
      style={styleObject}
      className={classNames(className, { [styles.multiline]: !!multiline })}
      ref={textRef}
      {...rest}
    >
      {children}
    </Variant>
  );
};

TruncatedText.propTypes = {
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span']),
  children: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  withoutTooltip: PropTypes.bool,
  multiline: PropTypes.bool,
  maxLines: PropTypes.number,
  className: PropTypes.string,
};

TruncatedText.defaultProps = {
  variant: 'p',
  multiline: false,
  withoutTooltip: false,
  maxLines: 2,
  children: '',
  width: 'unset',
  className: undefined,
};

export default TruncatedText;
